<template>
  <div>
    <Apptab />
    <v-container>
    <h2>Översikt</h2>
    <v-row>
    <v-card
    class="mx-auto"
    min-width="344"
  >
    <v-card-text>
      <h1 class="text-center">{{schedule.schedule}}</h1>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn
        text
        class="themecolor"
        to="/account/schedules"
      >
        Scheman
      </v-btn>
    </v-card-actions>
  </v-card>
  <v-card
    class="mx-auto"
    min-width="344"
    min-height="200"
  >
    <v-card-text class="mx-auto">
      <h1 class="text-center">{{schedule.comments}}</h1>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn
        text
        class="themecolor"
        to="/account/comments"
      >
        Kommentarer
      </v-btn>
    </v-card-actions>
  </v-card>
  </v-row>
  <v-row>
  <h2>Schemalägg ett möte</h2>
   </v-row>
  <v-row>
  <p>Planerar du ett möte med vänner eller kollegor? Vårt verktyg kommer att vara en stor hjälp både för dig och för alla som deltar.</p>
  
  </v-row>
  <v-row>
  <v-btn
        text
        class="themecolor"
        to="/"
      >
        Schemalägg ett möte
      </v-btn>
       </v-row>
    </v-container>
    <!-- <v-app-bar color="dark">
      <h1>Instrumentbräda</h1>
      <v-spacer />
      <v-btn style="color:#ffa500" text @click="reloadPage"
        ><v-icon>fas fa-sync</v-icon></v-btn
      >
      <router-link to="createmeeting">
        <v-btn style="color:#ffa500" text><v-icon>fas fa-plus</v-icon> </v-btn>
      </router-link> -->
    <!-- <div>
      <v-row class="hidden-sm-and-down">
        <v-container style="width:40%">
          <h2>Inkommande</h2>
          <Incoming />
        </v-container>
        <v-container style="width:40%"
          ><h2>Utgående</h2>
          <Outgoing />
        </v-container>
      </v-row>
      <v-container class="hidden-md-and-up">
        <h2>Inkommande</h2>
        <Incoming />
      </v-container>
      <v-container class="hidden-md-and-up"
        ><h2>Utgående</h2>
        <Outgoing />
      </v-container>
    </div> -->
  </div>
</template>

<script>
import axios from "axios";
import store from "../../store";
import Apptab from "./account/apptab";
// import Outgoing from "./showevents/outgoing";
// import Incoming from "./showevents/incoming";
export default {
  name: "Dashboard",
  components: {
    Apptab,
    // Outgoing,
    // Incoming,
  },
  created: async function() {
    if (!this.store.state.isLoggedIn) this.$router.replace("/login");
    if (this.store.state.user.role == "admin")
      this.$router.replace("/admin/dashboard");
      var config = {
            method: "get",
            url: `${this.store.state.baseURL}schedulecount/${this.store.state.user.id}`,
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            }
        };
        let resp = await axios(config);
        this.schedule = resp.data;
  },
  data: () => ({
    isLoggedIn: null,
    store: store,
    schedule: '',
  }),
  methods: {
    reloadPage() {
      window.location.reload();
    },
  },
};
</script>
<style>
.themecolor {
  color:#ffa500 !important;
}
</style>